module.exports = __webpack_public_path__ + "static/img/img(17).2dff207.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(17).png
// module id = V0kV
// module chunks = 1